module.exports = __webpack_public_path__ + "static/media/icon.66d558f1.webp";